var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.loaded)?_c('clinician-program-form',{attrs:{"action":_vm.action,"program":_vm.program,"program-types":_vm.programTypes},on:{"submitProgram":_vm.submitProgram}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }